import React, { useEffect } from 'react';
import OwlCarousel from 'react-owl-carousel';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from "react-redux";
import ArrowLeftLineIcon from 'remixicon-react/ArrowLeftLineIcon';
import { Link } from "react-router-dom";
import AuthActions from '../redux/auth/actions';
import Button from "../components/utils/Button";
import Alert from '../components/utils/Alert';
// import sideImage from '../assets/images/slide-1.png';
// import sideImagetwo from '../assets/images/slide-2.png';
// import sideImagethree from '../assets/images/slide-3.png';
// import logo from '../assets/images/logo-white.png'
import mailIcon from '../assets/images/mail.png'
import Long from '../../src/assets/images/Long.png'

const { forgetPassword, authReset, getAdminDetailes } = AuthActions;
const APP_BASEURL = process.env.REACT_APP_BASEURL;

const ForgetPassword = () => {
    const dispatch = useDispatch();
    const Auth = useSelector((state) => state.auth);
    const { register, handleSubmit, formState: { errors }, } = useForm();
    useEffect(() => {
        dispatch(getAdminDetailes());
        dispatch(authReset());
    }, []);

    const handleForgetPassword = (data) => {
        dispatch(forgetPassword(data));
    }
    // style={style.backbtn}

    return (
        <>       
<section className="sign-in-page">
    <div className="sign-page-inner-layer">

        {/* Left Illustration */}
        <div
            data-dc-tpl="18"
            style={{
                position: "absolute",
                left: "21px",
                bottom: "-35px",
            }}
        >
           <svg data-dc-tpl="19" width="180" height="248" viewBox="0 0 320 260" fill="none" stroke="#0E0E10" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line data-dc-tpl="20" x1="0" y1="250" x2="320" y2="250"></line><rect data-dc-tpl="21" x="14" y="170" width="62" height="80" fill="#FFFFFF"></rect><path data-dc-tpl="22" d="M36 236 C36 210 48 196 58 190"></path><path data-dc-tpl="23" d="M49 187 L58 190 L56 199"></path><rect data-dc-tpl="24" x="76" y="140" width="66" height="110" fill="#F8CBC7"></rect><path data-dc-tpl="25" d="M104 120 L166 116 L192 190 L176 196 L154 140 L104 140 Z" fill="#FFFFFF"></path><ellipse data-dc-tpl="26" cx="188" cy="201" rx="14" ry="7" fill="#0E0E10" transform="rotate(-15 188 201)"></ellipse><path data-dc-tpl="27" d="M92 140 L96 84 Q98 72 112 72 Q126 72 128 86 L130 140 Z" fill="#0E0E10"></path><path data-dc-tpl="28" d="M100 96 l6 -3 M110 106 l6 -3 M102 120 l6 -3 M114 126 l6 -3 M119 92 l6 -3" stroke="#FFFFFF" stroke-width="2"></path><circle data-dc-tpl="29" cx="114" cy="54" r="13" fill="#F5C6B0"></circle><path data-dc-tpl="30" d="M101 54 Q101 38 115 38 Q128 38 127 52 Q118 46 101 54 Z" fill="#0E0E10"></path><circle data-dc-tpl="31" cx="108" cy="33" r="7" fill="#0E0E10"></circle><circle data-dc-tpl="32" cx="121" cy="57" r="1.4" fill="#0E0E10" stroke="none"></circle><path data-dc-tpl="33" d="M122 88 L148 100" stroke-width="9"></path><circle data-dc-tpl="34" cx="152" cy="99" r="6" fill="#F5C6B0"></circle><rect data-dc-tpl="35" x="156" y="80" width="14" height="26" rx="3" fill="#D4333A" transform="rotate(15 163 93)"></rect><path data-dc-tpl="36" d="M178 78 A14 14 0 0 1 182 102" stroke="#D4333A"></path><path data-dc-tpl="37" d="M187 70 A24 24 0 0 1 192 110" stroke="#D4333A"></path><path data-dc-tpl="38" d="M60 38 L72 50 M86 28 L86 42 M50 60 L63 64"></path></svg>
        </div>

        {/* Right Illustration */}
        <div
            data-dc-tpl="39"
            style={{
                position: "absolute",
                right: "21px",
                bottom: "-35px",
            }}
        >
            <svg data-dc-tpl="40" width="180" height="248" viewBox="0 0 340 260" fill="none" stroke="#0E0E10" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line data-dc-tpl="41" x1="0" y1="250" x2="340" y2="250"></line><rect data-dc-tpl="42" x="10" y="176" width="70" height="74" fill="#FFFFFF"></rect><rect data-dc-tpl="43" x="80" y="126" width="76" height="124" fill="#F8CBC7"></rect><g data-dc-tpl="44" fill="#D4333A" stroke="none"><rect data-dc-tpl="45" x="96" y="218" width="9" height="14"></rect><rect data-dc-tpl="46" x="110" y="206" width="9" height="26"></rect><rect data-dc-tpl="47" x="124" y="194" width="9" height="38"></rect><rect data-dc-tpl="48" x="138" y="182" width="9" height="50"></rect></g><path data-dc-tpl="49" d="M262 250 L282 80 L302 250"></path><path data-dc-tpl="50" d="M267 210 L297 210 M271 170 L293 170 M276 130 L288 130 M267 210 L293 170 M297 210 L271 170 M271 170 L288 130 M293 170 L276 130"></path><path data-dc-tpl="51" d="M282 80 L282 64"></path><circle data-dc-tpl="52" cx="282" cy="62" r="7" fill="#D4333A"></circle><path data-dc-tpl="53" d="M292.3 49.7 A16 16 0 0 1 292.3 74.3" stroke="#D4333A" transform="translate(0 6)"></path><path data-dc-tpl="54" d="M300 40.6 A28 28 0 0 1 300 83.4" stroke="#D4333A" transform="translate(0 0)"></path><path data-dc-tpl="55" d="M271.7 55.7 A16 16 0 0 0 271.7 80.3" stroke="#D4333A" transform="translate(0 0)"></path><path data-dc-tpl="56" d="M264 40.6 A28 28 0 0 0 264 83.4" stroke="#D4333A"></path><path data-dc-tpl="57" d="M186 62 C174 62 174 44 188 44 C190 30 212 28 216 42 C230 38 236 58 222 62 Z"></path></svg>
        </div>

        {/* Header */}
        <div className="container-fluid">
            <div className="row align-items-center">
                <div className="col-xl-6 col-lg-6 col-md-6 col-6">
                    <div className="d-flex align-items-center justify-content-start">
                        <Link to="/">
                            <img
                                src={`${APP_BASEURL}/dealerLogo/${Auth.getAdminDetailsData.DealerLogo}`}
                                alt="Logo"
                                style={{ height: "85px" }}
                            />
                        </Link>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-6 col-6">
                    <div className="logo-header-icon">
                        <div className="sim-cir-cul">
                            <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#fff"
  strokeWidth="1.7"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M8 2h6l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2z" />
  <rect x="7" y="10" width="10" height="9" rx="1" />
  <path d="M10 10v3h4v-3M10 19v-3h4v3" />
</svg>
                        </div>

                        <div className="wifi-cir-cul">
                            <svg data-dc-tpl="14" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path data-dc-tpl="15" d="M5 12.5a10 10 0 0 1 14 0"></path><path data-dc-tpl="16" d="M8.5 16a5 5 0 0 1 7 0"></path><circle data-dc-tpl="17" cx="12" cy="19.5" r="1"></circle></svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Forgot Password Card */}
        <div className="container mt-lg-2 mt-xl-2 pt-3">
            <div className="row no-gutters justify-content-center">
                <div className="col-xl-5 col-lg-5 col-md-8 col-sm-12 col-12 bg-white px-4 pb-3 rounded border align-self-center">

                    {!Auth.forgetPasswordMessage ? (
                        <>
                            <div className="mb-3 mt-4">
                                <Link
                                    to="/sign-in"
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <ArrowLeftLineIcon
                                        color="#294c28eb"
                                        size={26}
                                    />
                                </Link>
                            </div>

                            <h2
                                className="mb-0 mt-2 text-start welcome-sign"
                                style={{ fontSize: "22px" }}
                            >
                                Forgot Password?
                            </h2>

                            <p
                                className="text-dark text-start"
                                style={{
                                    fontSize: "15px",
                                    borderBottom: "2px solid #050405",
                                    paddingBottom: "12px",
                                }}
                            >
                                Enter your username and we'll send you an
                                email with instructions to reset your password.
                            </p>

                            {Auth.forgetPasswordError ? (
                                <Alert
                                    type="alert-danger"
                                    text={Auth.forgetPasswordError}
                                />
                            ) : null}

                            <form
                                className="mt-3"
                                onSubmit={handleSubmit(handleForgetPassword)}
                            >
                                <div className="form-group">
                                    <label htmlFor="username">
                                        Username
                                    </label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        name="username"
                                        id="username"
                                        placeholder="Enter username"
                                        {...register("username", {
                                            required: true,
                                        })}
                                    />

                                    {errors.username?.type === "required" && (
                                        <div className="invalid-feedback d-block">
                                            Username is required
                                        </div>
                                    )}
                                </div>

                                <div
                                    className="d-inline-block w-100 mt-3"
                                    id="btn-main-footer"
                                >
                                    <Button
                                        title="Reset Password"
                                        buttonClass="btn btn-primary w-100"
                                        style={{
                                            borderRadius: "8px",
                                            height: "38px",
                                        }}
                                        loading={Auth.forgetPasswordLoading}
                                        buttonType="submit"
                                    />
                                </div>

                                <div className="text-center mt-3">
                                    <span className="text-muted">
                                        Remember your password?{" "}
                                    </span>
                                    <Link to="/sign-in">
                                        Sign in
                                    </Link>
                                </div>
                            </form>
                        </>
                    ) : (
                        /* Success State */
                        <div className="text-center py-4">
                            <img
                                src={mailIcon}
                                width="80"
                                alt="Email sent"
                            />

                            <h2 className="mt-3 mb-2 welcome-sign">
                                Success!
                            </h2>

                            <p className="text-dark">
                                Please check your email to reset your password.
                            </p>

                            <div className="d-inline-block w-100 mt-3" id='btn-main-footer'>
                                <Link
                                    to="/sign-in"
                                    className="btn btn-primary text-white w-100"
                                    style={{
                                        borderRadius: "8px",
                                        lineHeight: "36px",
                                    }}
                                >
                                    Back to Sign In
                                </Link>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    </div>
</section>

        </>
    )
}



export default ForgetPassword